interface NumberOption {
  value: string | number
  name: string
}

export function generateModelYearOptions(valuesAsStrings = false, startYear = 2004) {
  const currentYear = new Date().getFullYear()
  const options: NumberOption[] = [{ value: '', name: 'Select' }]
  options.push({ value: 'New', name: 'New' })

  for (let year = currentYear; year >= startYear; year--) {
    options.push({ value: valuesAsStrings ? year.toString() : year, name: year.toString() })
  }

  options.push({ value: 'older', name: 'Older' })
  return options
}

export function generateAddressYearsOptions() {
  const options: NumberOption[] = [{ value: '', name: 'Years' }]

  for (let year = 0; year <= 50; year++) {
    options.push({
      value: year,
      name: year.toString() + (year === 1 ? ' year' : year === 0 ? ' years' : ' years')
    })
  }

  return options
}

export function generateMonthOptions(withMonthName = false) {
  const options: NumberOption[] = [{ value: '', name: 'Months' }]
  if (withMonthName) {
    for (let month = 0; month <= 11; month++) {
      if (month === 1) {
        options.push({ value: month, name: `${month} month` })
      } else {
        options.push({ value: month, name: `${month} months` })
      }
    }
  } else {
    for (let month = 1; month <= 11; month++) {
      options.push({ value: month, name: month.toString() })
    }
  }

  return options
}

export function generateYearsOptions(withYearName = false, years = 50) {
  const options: NumberOption[] = [{ value: '', name: 'Years' }]
  if (withYearName) {
    for (let year = 0; year <= years; year++) {
      if (year === 1) {
        options.push({ value: year, name: `${year} year` })
      } else {
        options.push({ value: year, name: `${year} years` })
      }
    }
  } else {
    for (let year = 0; year <= years; year++) {
      options.push({ value: year, name: year.toString() })
    }
  }
  return options
}

export function generateAgeOptions(startYear = 1, endYear = 99) {
  const options: NumberOption[] = [{ value: '', name: 'Select' }]
  for (let year = startYear; year <= endYear; year++) {
    options.push({
      value: year,
      name: year.toString() + (year === 1 ? ' year' : year === 0 ? '' : ' years')
    })
  }

  return options
}